import TelephoneIcon from '@/common/assets/icons/phoneIcon.svg?react';
import CustomIcon from '@/common/components/base/customIcon/CustomIcon';
import BulletTypography from '@/common/components/base/typography/BulletTypography';
import Typography from '@/common/components/base/typography/Typography';
import BaseCheckBox from '@/common/components/BaseCheckbox/BaseCheckBox';
import { ScheduleVisitListComponentProps } from '@/common/components/scheduleVisitListComponent/ScheduleVisitListComponent.type';
import convertTimestampToShamsi from '@/common/utils/convertTimestampToShamsi';
import React from 'react';
import { Box, Flex } from 'styled-system/jsx';
import { token } from 'styled-system/tokens';

const ScheduleVisitListComponent: React.FC<ScheduleVisitListComponentProps> = (
  props,
) => {
  const { listData, onChange, checked } = props;
  return (
    <Box bg="white" boxShadow="cardShadow" borderRadius={8} p={16}>
      {/* ========= Header Card ========= */}
      <Box borderBottom="1px dashed" borderColor="gray-3" pb={8}>
        <Box display="flex" flexDir="row" alignItems="center" gap={8}>
          <Box onClick={() => onChange(listData)}>
            <label htmlFor={`${props.listData.id}`}>
              <BaseCheckBox checked={checked} id={`${props.listData.id}`} />
            </label>
          </Box>
          <Box borderLeft="1px solid" borderColor="gray-3" height="17px"></Box>
          <Typography textStyle="b4">
            {listData?.user_type?.fa_const}
          </Typography>
        </Box>
      </Box>
      {/* ========= Body Card ========= */}
      <ListItemTimeSet
        title="نام"
        value={listData?.first_name + ' ' + listData?.last_name}
      />
      <ListItemTimeSet
        title="تلفن همراه : "
        value={listData?.phone_number}
        icon={
          <a href={`tel:${listData?.phone_number}`}>
            <CustomIcon backgroundColor="green-4" width={26} height={26}>
              <TelephoneIcon stroke={token('colors.green')} />
            </CustomIcon>
          </a>
        }
      />
      <ListItemTimeSet
        title="زمان بازدید :"
        value={
          listData?.visit_date ? (
            convertTimestampToShamsi(+listData?.visit_date)
          ) : (
            <Typography textStyle="b2" color="red-1">
              تعیین نشده
            </Typography>
          )
        }
      />
      <ListItemTimeSet title="آدرس بازدید :" value={listData?.visit_location} />
    </Box>
  );
};
export default ScheduleVisitListComponent;

type ListItemTimeSetProps = {
  title: string;
  value: string | React.ReactNode;
  icon?: React.ReactNode;
};
const ListItemTimeSet: React.FC<ListItemTimeSetProps> = (props) => {
  const { title, value, icon } = props;
  return (
    <Flex alignItems="center" justifyContent="space-between" mt={16}>
      <BulletTypography
        backgroundColor="purple-3"
        textStyle="b2"
        color="black-3"
      >
        {title}
      </BulletTypography>
      <Flex alignItems="center" gap={4} maxW={160} overflow="hidden">
        {icon && icon}
        <Typography
          textStyle="b2"
          color="black-1"
          overflow="hidden"
          textOverflow="ellipsis"
          whiteSpace="nowrap"
          display="block"
        >
          {value}
        </Typography>
      </Flex>
    </Flex>
  );
};
